import ReactDOM from 'react-dom/client';
import { HashRouter, Route, Routes } from 'react-router-dom';
import { StyleSheetManager } from 'styled-components';
import { theme as Theme } from '@vivaahealth/design-system';
import * as Sentry from '@sentry/react';

import Fonts from './styles/fonts';

import reportWebVitals from './reportWebVitals';

import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import AssistantRenders from './scenes/AssistantRenders';
import CloseWindow from './scenes/CloseWindow';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://35ad83da00f295af8c1bf8723ee03b38@o111996.ingest.sentry.io/4505869871480832',
    integrations: [
      new Sentry.BrowserTracing({
        tracePropagationTargets: [/^https:\/\/app.notablehealth.com/],
      }),
      new Sentry.Replay(),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.5,
    // Session Replay
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.2,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
const queryClient = new QueryClient();

root.render(
  <StyleSheetManager enableVendorPrefixes>
    <QueryClientProvider client={queryClient}>
      <Fonts />
      <Theme.ThemeProvider>
        <HashRouter>
          <Routes>
            <Route path="/close" element={<CloseWindow />} />
          </Routes>
          <AssistantRenders />
        </HashRouter>
      </Theme.ThemeProvider>
    </QueryClientProvider>
  </StyleSheetManager>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
